export const UNHAUTORIZED_MESG = {message:"Non autorisé"};


// WEBPACK FOOTER //
// ./src/store/actions/messages.js